import {ACTION_CODE} from './_actionCode';
import {DealAbandonmentMotivesDao} from '../../dao';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'CREATE_DEALLOSSMOTIVE';

export async function createDealAbandonmentMotive(userData: Record<string, any>, payload: Record<string, any>) {
    try {
        LoggerService.logInfo('Action - createDealAbandonmentMotive - Start');

        const createDealLossMotiveResult = await DealAbandonmentMotivesDao.createDealAbandonmentMotive(userData.userToken, payload);

        LoggerService.logInfo('Action - createDealAbandonmentMotive - End - Success');

        return ResultModel.newSuccessResult(createDealLossMotiveResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - createDealAbandonmentMotive - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: "Une erreur est survenue lors de la création d'un motif d'abandon",
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
